module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-challenge-videoPoster.jpg?h=1ddb20a0b8250ff512dd0e2647f7839e";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-challenge-videoPoster.jpg
// module id = 2124
// module chunks = 12 15